import { tradeRecords } from '@/mocks/tradingData';

export interface SequenceMark {
  id: number;
  profit: boolean;
  result: string;
}

const formatSigned = (n: number): string =>
  `${n < 0 ? '-' : '+'}${Math.abs(n).toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;

// Derived, never stored. One mark per closed trade, kept in the exact order the
// trades occurred. This lets a page show the record as a real sequence — wins
// and losses interleaved as they actually happened — instead of a rearranged
// summary. It reads the same single ledger everything else reads.
export const recordSequence: SequenceMark[] = tradeRecords.map((t) => ({
  id: t.id,
  profit: t.profit > 0,
  result: formatSigned(t.profit),
}));